import { Accordion, Card, HiddenVisually, Text, useViewport, useTheme } from "@bookingcom/bui-react";
import NoSSR from "../../../app/NoSSR/index.js";
import React from "react";
import { Sidebar } from "../Container/index.js";
import { DSATraceabilityPopover } from "../FlightDetailsInner/components/DSATraceability/index.js";
import Frame from "../Frame/index.js";
import SearchFiltersDesktop from "../SearchFilters/SearchFilters.desktop.js";
import SearchFiltersSummary from "../SearchFiltersSummary/index.js";
import AiSummaryDesktop from "./components/AiSummary.desktop.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { DESKTOP_SIDEBAR_WIDTH } from "../../../constants.js";
import styles from "./SearchResults.desktop.module.css";
const attributes = { style: { width: `calc(100% - ${DESKTOP_SIDEBAR_WIDTH}px)` } };
const SearchResultsWrapperDesktop = ({ children, banners, showGenAiSummary = false }) => {
    const i18n = useI18n();
    const { isLarge } = useViewport();
    const theme = useTheme();
    return (React.createElement("div", { className: styles.searchResults, "data-testid": "searchresults_list" },
        React.createElement(NoSSR, null,
            React.createElement(Frame, { direction: "row" },
                isLarge ? (React.createElement(Sidebar, null,
                    showGenAiSummary && React.createElement(AiSummaryDesktop, null),
                    React.createElement(Frame, { pb: 3 },
                        React.createElement(SearchFiltersSummary, null)),
                    React.createElement(SearchFiltersDesktop, null),
                    React.createElement(DSATraceabilityPopover, null))) : null,
                React.createElement(Frame, { direction: "column", grow: 1, pb: 4, pl: !isLarge ? 0 : 6, attributes: attributes },
                    !isLarge ? (React.createElement(React.Fragment, null,
                        showGenAiSummary && React.createElement(AiSummaryDesktop, null),
                        React.createElement(Card, { attributes: { style: { marginBottom: theme.units.spacing_6x } } },
                            React.createElement(Accordion, { titleContent: React.createElement(SearchFiltersSummary, { isCompact: true }) },
                                React.createElement(React.Fragment, null,
                                    React.createElement(SearchFiltersDesktop, null),
                                    React.createElement(DSATraceabilityPopover, null)))))) : null,
                    React.createElement(HiddenVisually, null,
                        React.createElement(Text, { tagName: "h2" }, i18n.trans(t("a11y_flights_sr__results_hidden_heading")))),
                    banners,
                    children)))));
};
export default React.memo(SearchResultsWrapperDesktop);
